// Scaffolded by the Supabase integration, then hand-maintained. (The sibling
// types.ts IS regenerated — `supabase gen types` writes that file and only
// that file. Nothing regenerates this one, so it is safe to edit; the old
// "automatically generated, do not edit" banner was boilerplate and stopped
// anyone touching it.)
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { fetchWithDeadline } from "./fetchWithDeadline";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
    // Give every query a deadline, so no call site can wait forever on a
    // database that has stopped answering. See ./fetchWithDeadline.ts.
    global: { fetch: fetchWithDeadline },
  },
);
